'use client';
import { lazy, type ComponentProps } from 'react';
export type * from "/tmp/build-440/overrides/pages/search/page.tsx";
const Deferred0 = lazy(() => import("@eliadmin/page-island-original/967ad4786260").then(m => ({ default: m.default })));
const Island0 = ((props: NonNullable<ComponentProps<typeof import("/tmp/build-440/overrides/pages/search/page.tsx").default>>) => <Deferred0 {...props} />) as typeof import("/tmp/build-440/overrides/pages/search/page.tsx").default;
export default Island0;
